var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"disabled":_vm.disableBtn},on:{"click":function($event){return _vm.createPPT()}}},[_vm._v("PPTX")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }